import React from "react";

type TabKey = string;
type Tab = { key: TabKey; label: string };
type TabsProps = { tabs: Tab[]; active: TabKey; onChange: (key: TabKey) => void };

export default function Tabs({ tabs, active, onChange }: TabsProps) {
  return (
    <div role="tablist" aria-label="Sections" className="inline-flex gap-1 bg-white/5 border border-slate-800 rounded-lg p-1 mb-4">
      {tabs.map((t) => (
        <button
          key={t.key}
          role="tab"
          aria-selected={active === t.key}
          onClick={() => onChange(t.key)}
          className={[
            "px-3 py-1.5 rounded-md text-sm",
            active === t.key ? "bg-slate-800 border border-slate-700" : "hover:bg-slate-800/50 border border-transparent",
          ].join(" ")}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}